import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: InvoiceState = {};

const rootState: InvoiceState = initialState;

const getters: GetterTree<InvoiceState, RootState> = {};

const mutations: MutationTree<InvoiceState> = {
  RESET(state: InvoiceState) {
    Object.assign(state, initialState);
  },
};

const actions: ActionTree<InvoiceState, RootState> = {};

export default {
  namespaced: true,
  state: rootState,
  getters,
  actions,
  mutations,
};
